module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-chgpwd/admin-chgpwd.component.css
// module id = ./src/app/admin-chgpwd/admin-chgpwd.component.css
// module chunks = main